import type { IconProps } from './Icon.types';

const ArrowIcon: React.FC<IconProps> = ({
  className,
  fill = 'currentColor',
  height = 13,
  width = 17,
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 17 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.06097 7.68791L13.3732 7.68791L9.87435 11.1867C9.67517 11.3859 9.56327 11.6561 9.56327 11.9378C9.56327 12.2195 9.67517 12.4896 9.87435 12.6888C10.0735 12.888 10.3437 12.9999 10.6254 12.9999C10.9071 12.9999 11.1772 12.888 11.3764 12.6888L16.6884 7.37679C16.7872 7.27825 16.8655 7.16119 16.919 7.03232C16.9725 6.90345 17 6.76529 17 6.62577C17 6.48625 16.9725 6.34809 16.919 6.21922C16.8655 6.09035 16.7872 5.97329 16.6884 5.87475L11.3764 0.562747C11.2766 0.461556 11.1574 0.3816 11.0259 0.327694C10.8945 0.273787 10.7534 0.247045 10.6114 0.249075C10.4014 0.249439 10.1963 0.311913 10.0219 0.428629C9.84742 0.545344 9.71141 0.711082 9.63097 0.904959C9.55052 1.09884 9.52926 1.31218 9.56985 1.51812C9.61043 1.72406 9.71106 1.91339 9.85905 2.06224L13.3732 5.56108L1.06352 5.56108C0.781483 5.56108 0.511 5.67311 0.311569 5.87254C0.112139 6.07197 9.91821e-05 6.34246 9.91821e-05 6.62449C9.91821e-05 6.90653 0.112139 7.17702 0.311569 7.37645C0.511 7.57588 0.781483 7.68791 1.06352 7.68791H1.06097Z"
      fill={fill || 'currentColor'}
    />
  </svg>
);

export default ArrowIcon;
